<template>
  <div class="step-card">
    <slot></slot>
  </div>
</template>
